import  './Search.scss';

export default function Search() {
    return (
      <>
        
        <div className="used-search-block" id="used-search-block">
            <div className="used-search-block__heading">

            </div>
            <div className="used-search-block__facets">
                <div className="used-search-block__facet used-search-block__vehicle-status">
                    <select id="vehicle-type" className="search-vehicle-type" name="vehicletype">
                        <option value="cars" data-count="68">Cars (68)</option>
                        <option value="vans" data-count="5">Vans (5)</option>
                    </select>
                </div>
                <div className="used-search-block__facet used-search-block__vehicle-status">
                    <select id="vehicle-type" className="search-vehicle-type" name="vehicletype">
                        <option value="cars" data-count="68">Cars (68)</option>
                        <option value="vans" data-count="5">Vans (5)</option>
                    </select>
                </div>
                <div className="used-search-block__facet used-search-block__vehicle-status">
                    <select id="vehicle-type" className="search-vehicle-type" name="vehicletype">
                        <option value="cars" data-count="68">Cars (68)</option>
                        <option value="vans" data-count="5">Vans (5)</option>
                    </select>
                </div>
                <div className="used-search-block__facet used-search-block__vehicle-status">
                    <select id="vehicle-type" className="search-vehicle-type" name="vehicletype">
                        <option value="cars" data-count="68">Cars (68)</option>
                        <option value="vans" data-count="5">Vans (5)</option>
                    </select>
                </div>
            </div>
            <div className="used-search-block__submit">
                <button type="submit" className="button search-button" rel="nofollow"><span>Search</span></button>
            </div>
        </div>

      </>
    );
  }
  